<p-card
  *ngIf="withCard"
  styleClass="mb-3 p-3 very-compact-card"
  header="Реквизиты по умолчанию">
  <ng-template [ngTemplateOutlet]="form"></ng-template>
</p-card>

<ng-container *ngIf="!withCard">
  <ng-template [ngTemplateOutlet]="form"></ng-template>
</ng-container>

<ng-template #form>
  <div class="p-fluid">
    <div class="field">
      <label class="font-medium">Сделка</label>
      <crm-deal-multi-select
        [(selectedDeals)]="subprojectDefaults.deals"
        appendTo="body"
        [disabled]="disabled"
        [isError]="$any(errors?.deals)"
        (selectedDealsChange)="changeDefaults.emit(subprojectDefaults)"></crm-deal-multi-select>
      <small
        *ngIf="errors?.deals"
        class="p-error"
        >{{ errors.deals | join }}</small
      >
    </div>

    <div class="field">
      <label class="font-medium">Клиент</label>
      <crm-single-select
        [options]="clients"
        [(selectedItem)]="subprojectDefaults.client"
        [styleClass]="errors?.client ? 'ng-invalid ng-dirty' : ''"
        [class]="errors?.client ? 'ng-invalid ng-dirty' : ''"
        appendTo="body"
        [disabled]="disabled"
        [showClear]="true"
        (selectedItemChange)="changeDefaults.emit(subprojectDefaults)"></crm-single-select>
      <small
        *ngIf="errors?.client"
        class="p-error">
        {{ errors.client | join }}
      </small>
    </div>

    <div class="field">
      <label class="font-medium">Эпик</label>
      <crm-master-milestone-single-select
        [(selectedMasterMilestone)]="subprojectDefaults.masterMilestone"
        (selectedMasterMilestoneChange)="changeDefaults.emit(subprojectDefaults)"
        [isError]="$any(errors?.masterMilestone)"
        [disabled]="disabled"
        appendTo="body"></crm-master-milestone-single-select>
      <small
        *ngIf="errors?.masterMilestone"
        class="p-error">
        {{ errors.masterMilestone | join }}
      </small>
    </div>

    <div class="field">
      <label class="font-medium">Бизнес единица</label>
      <crm-unit-single-select
        [(selectedUnit)]="subprojectDefaults.unit"
        (selectedUnitChange)="changeDefaults.emit(subprojectDefaults)"
        [isError]="$any(errors?.unit)"
        [showClear]="true"
        [disabled]="disabled"
        appendTo="body"></crm-unit-single-select>
      <small
        *ngIf="errors?.unit"
        class="p-error">
        {{ errors.unit | join }}
      </small>
    </div>

    <div class="field">
      <label class="font-medium">Бюджетная статья</label>
      <crm-direction-single-select
        [directions]="directions"
        [(selectedDirection)]="subprojectDefaults.direction"
        [groupsDisabled]="true"
        [styleClass]="errors?.direction ? 'ng-invalid ng-dirty' : ''"
        [class]="errors?.direction ? 'ng-invalid ng-dirty' : ''"
        [showClear]="true"
        [disabled]="disabled"
        appendTo="body"
        (selectedDirectionChange)="changeDefaults.emit(subprojectDefaults)">
      </crm-direction-single-select>
      <small
        *ngIf="errors?.direction"
        class="p-error">
        {{ errors.direction | join }}
      </small>
    </div>

    <div class="field">
      <label class="font-medium">Пользователи</label>
      <crm-user-multi-select
        [(selectedUsers)]="subprojectDefaults.userAuditors"
        (selectedUsersChange)="changeDefaults.emit(subprojectDefaults)"
        [isError]="$any(errors?.userAuditors)"
        [isFloatLabel]="false"
        [disabled]="disabled"
        appendTo="body"></crm-user-multi-select>
      <small
        *ngIf="errors?.userAuditors"
        class="p-error">
        {{ errors.userAuditors | join }}
      </small>
    </div>

    <div class="field">
      <label class="font-medium">Группы</label>
      <crm-multi-select
        [(selectedItems)]="subprojectDefaults.userGroupAuditors"
        [options]="userGroups"
        appendTo="body"
        [disabled]="disabled"
        [class]="errors?.userGroupAuditors ? 'ng-invalid ng-dirty' : ''"
        [styleClass]="errors?.userGroupAuditors ? 'ng-invalid ng-dirty' : ''"
        (selectedItemsChange)="changeDefaults.emit(subprojectDefaults)">
      </crm-multi-select>
      <small
        *ngIf="errors?.userGroupAuditors"
        class="p-error">
        {{ errors.userGroupAuditors | join }}
      </small>
    </div>
  </div>
</ng-template>
